import { render, staticRenderFns } from "./ProtectionDetails.vue?vue&type=template&id=ad3c9b1c&scoped=true&"
import script from "./ProtectionDetails.vue?vue&type=script&lang=js&"
export * from "./ProtectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProtectionDetails.vue?vue&type=style&index=0&id=ad3c9b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3c9b1c",
  null
  
)

export default component.exports